import { 
  Toast,
  List,
  ImagePreview,
  Checkbox,
  CheckboxGroup,
  Dialog,
  ActionSheet,
  Popup,
  Collapse,
  CollapseItem,
  Icon,
  Button,
  Cell,
  Form,
  Field,
  Uploader,
} from 'vant';
import '@vant/touch-emulator';

export default {
  install: (Vue) => {
    Vue.use(Toast);
    Vue.use(List);
    Vue.use(Checkbox);
    Vue.use(CheckboxGroup);
    Vue.use(Dialog);
    Vue.use(ActionSheet);
    Vue.use(Popup);
    Vue.use(Collapse);
    Vue.use(CollapseItem);
    Vue.use(Icon);
    Vue.use(Button);
    Vue.use(Cell);
    Vue.use(Form);
    Vue.use(Field);
    Vue.use(Uploader);
    Vue.prototype.$imagePreview = ImagePreview;
  }
}